<template>
  <div class="teacher-login-page">
    <div class="login-admin-title">
      <mt-header title="登录">
        <router-link to="/" slot="left">
          <mt-button icon="back"></mt-button>
        </router-link>
      </mt-header>
    </div>
    <div class="login-school-admin">
      <div class="login-school-admin-content">
        <div class="login-school-show">
          <div class="login-school-img-box">
            <img src="../../assets/images/login-sinlg.png" alt="">
          </div>
          <div class="login-school-name">{{ schoolName ? schoolName : '' }}</div>
          <div class="login-identity-text">教师登录</div>
        </div>
        <!-- 登录模块 -->
        <div>
          <mt-navbar v-model="selectedType">
            <mt-tab-item id="1"> <span @click="pswLogin">账号密码登录</span> </mt-tab-item>
            <mt-tab-item id="2"> <span @click="PhLogin">验证码登录</span> </mt-tab-item>
          </mt-navbar>

          <mt-tab-container v-model="selectedType">

            <mt-tab-container-item id="1">
              <mt-field placeholder="请输入用户名" v-model="username" disableClear></mt-field>
              <mt-field placeholder="请输入密码" :type="isShowPassword ? 'password' : 'text'" v-model="password" disableClear>
                <img v-if="!isEye" src="../../assets/images/open-eye.png" alt="" @click="closePassword">
                <img v-else src="../../assets/images/close-eye.png" alt="" @click="openPassword">
              </mt-field>
              <div class="login-tip">
                <div class="rememberPassword">
                  <mt-checklist v-model="TeacherrememberPassword" :options="options" @change="checkon"> </mt-checklist>
                </div>
                <a class="find-pws" @click="openForgetPassword()">忘记密码</a>
              </div>
            </mt-tab-container-item>

            <mt-tab-container-item id="2">
              <mt-field placeholder="请输入手机号" v-model="phone"></mt-field>
              <mt-field placeholder="请输入验证码" v-model="verifyCode">
                <span class="get-code" @click="checkPhone(phone)" :style="time < 60 && time > 0 ? 'color:#999' : ''">
                  {{ valiText }}
                </span>
              </mt-field>
            </mt-tab-container-item>
          </mt-tab-container>
          <mt-button :disabled="btnClick" class="btn1" type="primary" @click="accountSubmit">确定</mt-button>
        </div>
      </div>
    </div>

    <!-- 忘记密码 -->
    <div class="mint-msgbox-wrapper" style="position: absolute; z-index: 2001;" v-show="forgetPasswordModel">
      <!-- 教师 -->
      <div class="mint-msgbox" v-show="loginRole == 0" style="max-width:320px">
        <div class="mint-msgbox-header">
          <div class="mint-msgbox-title">教师如何找回密码</div>
        </div>
        <div class="mint-msgbox-content" style="overflow: auto;max-height: 500px;text-align: center;">
          <div style="padding: 0 20px;color: darkgray;" id="module1">
            <p>1、进入<a href="https://m.21cnjy.com/" target="_blank" style="color:red">21世纪教育网</a>&nbsp;选择账号密码登录，点击“忘记密码”。</p>
            <p><img :src="bdsjUrl1" width="100%" style=" max-width:300px;max-height:300px;" /></p>
            <p>2、输入手机号码验证后，设置新密码登录</p>
            <p><img :src="bdsjUrl2" width="100%" style="max-width:300px;max-height:300px;" /></p>
            <p>PS:若没有绑定手机号码，请联系管理员或客服工作人员</p>
          </div>
        </div>

        <div class="mint-msgbox-btns">
          <button class="mint-msgbox-btn mint-msgbox-cancel" @click="closeForgetPassword">取消</button>
          <button class="mint-msgbox-btn mint-msgbox-confirm" @click="forgetPasswordOK">前往找回</button>
        </div>
      </div>
    </div>

    <!-- 绑定手机号码 -->
    <div class="mint-msgbox-wrapper" style="position: absolute; z-index: 2001;" v-show="bindingPhoneModel">
      <!-- 教师 -->
      <div class="mint-msgbox" v-show="loginRole == 0" style="max-width:320px">
        <div class="mint-msgbox-header">
          <div class="mint-msgbox-title">教师如何绑定手机号码</div>
        </div>
        <div class="mint-msgbox-content" style="max-height: 555px; text-align: center;">
          <div style="padding: 0 20px; color: darkgray;" id="module1">
            <p>1、进入<a href="https://m.21cnjy.com/" target="_blank" style="color:red">21世纪教育网</a>&nbsp;选择账号密码登录，输入你的数字化校园账号和密码</p>
            <p><img :src="bdsjUrl1" width="100%" style=" max-width:300px;max-height:300px;" /></p>
            <p>2、输入账号密码后，进入个人中心--账号安全，输入手机号及验证。</p>
            <p><img :src="bdsjUrl3" width="100%" style="max-width:300px;max-height:300px;" /></p>
            <p>PS:若已在21世纪教育实名过手机，则登录后在个人中心进行手机号绑定</p>
          </div>
        </div>
        <div class="mint-msgbox-btns">
          <button class="mint-msgbox-btn mint-msgbox-cancel" @click="closeBindingPhoneModel">取消</button>
          <button class="mint-msgbox-btn mint-msgbox-confirm" @click="forgetPasswordOK">前往绑定</button>
        </div>
      </div>
    </div>

    <div class="v-modal" style="z-index: 2000;" v-show="forgetPasswordModel || bindingPhoneModel"> </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Header, Navbar, TabItem, Field, Checklist, Button, MessageBox } from 'mint-ui';
Vue.component(Header.name, Header);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(Field.name, Field);
Vue.component(Button.name, Button);
Vue.component(Checklist.name, Checklist);
// const ip = require('ip');
// const IP = ip.address();
import bdsj_1 from '@/assets/images/bdsj_1.png'
import bdsj_2 from '@/assets/images/bdsj_2.png'
import bdsj_3 from '@/assets/images/bdsj_3.png'
export default {
  data() {
    return {
      isEye: true,
      isShowPassword: true,
      schoolName: '',
      time: 60,
      username: '',
      schoolId: '',
      password: '',
      selectedType: '1',
      loginRole: '0',
      phone: '',
      verifyCode: '',
      btnClick: true,
      TeacherrememberPassword: [],
      options: [{
        label: "记住密码",
        value: '1',
      }],
      valiText: '获取验证码',
      classText: 'u-btn ft-btn1',
      forgetPasswordModel: false,
      bdsjUrl1: bdsj_1,
      bdsjUrl2: bdsj_2,
      bdsjUrl3: bdsj_3,
      bindingPhoneModel: false,
    }
  },
  watch: {
    "username": function () {
      this.btnClick = this.username && this.password ? false : true;
      this.classText = this.username && this.password ? 'bind' : 'ft-btn1';
    },
    "password": function () {
      this.btnClick = this.username && this.password ? false : true;
      this.classText = this.username && this.password ? 'bind' : 'ft-btn1';
    },
    "phone": function () {
      this.btnClick = this.phone && this.verifyCode ? false : true;
      this.classText = this.phone && this.verifyCode ? 'bind' : 'ft-btn1';
    },
    "verifyCode": function () {
      this.btnClick = this.phone && this.verifyCode ? false : true;
      this.classText = this.phone && this.verifyCode ? 'bind' : 'ft-btn1';
    },
  },

  //   created() {
  //     console.log(JSON.parse(localStorage.getItem("account_info")), 'sssssssssss');
  //     try {
  //       let account_info = JSON.parse(localStorage.getItem("account_info"));
  //       if (_.isEmpty(account_info) || !account_info || account_info.checked != 1) return false;
  //       this.TeacherrememberPassword[0] = "1";
  //       this.password = account_info.password;
  //       this.username = account_info.userName;
  //       console.log(account_info, 'account_info');
  //       this.btnClick = false
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   },
  mounted() {
    this.schoolName = this.$route.query.schoolName;
    this.schoolId = this.$route.query.schoolId;
    if (!this.schoolName || !this.schoolId) {
      this.$router.replace({ name: 'Login' });
      return
    }
    try {
      var num = parseInt(localStorage.getItem("TeacherrememberPassword"))
      if (num == 1) {
        this.TeacherrememberPassword = [num]
      }
      let account_info = JSON.parse(localStorage.getItem("TeacherloginPws"));
      if (this.TeacherrememberPassword[0] == 1 || this.TeacherrememberPassword[0] == '1') {
        this.password = account_info.password;
        this.username = account_info.userName;
        this.btnClick = false
      }   
    } catch(err) {
      return
    }
  },
  methods: {
    checkon(val) {
      if (val[0] == 1) {
        localStorage.removeItem("TeacherrememberPassword")
        localStorage.setItem("TeacherrememberPassword", 1)
      } else {
        localStorage.removeItem("TeacherrememberPassword")
        localStorage.removeItem("TeacherloginPws")
        localStorage.setItem("TeacherrememberPassword", 0)
      }

    },
    PhLogin() {
      this.btnClick = true
      this.phone = '';
      this.verifyCode = '';
    },
    pswLogin() {
      if (this.username && this.password) {
        this.btnClick = false
      }
      //   this.username = '';
      //   this.password = '';
    },
    // 查看密码
    openPassword() {
      this.isEye = false
      this.isShowPassword = false
    },
    // 关闭密码
    closePassword() {
      this.isEye = true
      this.isShowPassword = true
    },
    accountSubmit() {
      if (this.selectedType == "1") {
        this.passWordLogin()
      } else {
        this.phoneLogin()
      }
      localStorage.removeItem("loginCount");
      localStorage.setItem('loginRole', this.loginRole)
    },
    passWordLogin() {
      let loginPws = {
        password: this.password,
        userName: this.username,
      }
      this.$http.post('/api/mobile/user/loginbind', {
        // ipAddress: encodeURI(IP),
        loginType: 'wechat',
        password: this.password,
        userName: this.username,
        wechat: '',
        loginRole: this.loginRole
      }).then(res => {
        if (res.data.code != 0) {
          MessageBox({
            title: '提示',
            message: res.data.message,
            showCancelButton: false
          });
        } else {
          // let account_info = { userName: this.username, password: this.password }
          // if (this.TeacherrememberPassword[0] == '1') {
          //     account_info.checked = 1;
          // } else {
          //     delete account_info['checked'];
          // }
          // localStorage.setItem("account_info", JSON.stringify(account_info));
          this.$router.replace({ name: 'Home' });
          let remPassword = localStorage.getItem("TeacherrememberPassword")
          if (remPassword == 1 || remPassword == '1') {
            this.TeacherrememberPassword = []
            localStorage.setItem("TeacherloginPws", JSON.stringify(loginPws))
          }
        }
      });
    },

    //手机验证码登录
    phoneLogin() {
      var data = {
        mobile: this.phone,
        verifyCode: this.verifyCode,
        loginRole: this.loginRole,
        schoolId: this.schoolId
      }
      this.$http.post('/api/mobile/user/verifyLogin', data, 'json').then(res => {
        if (res.data.code == 0) {
          this.$router.replace({ name: 'Home' });
        } else {
          MessageBox.alert(res.data.message, res.data.title);
        }
      })
    },
    // 获取验证码
    sendVerifyCode(phone) {
      this.$http.post('/api/mobile/user/sendVerifyCode', { phone: phone, loginRole: this.loginRole, schoolId: this.schoolId }).then(res => {
        if (res.data.code == 0 || res.data.code == "0") {
          this.getTerm()
          MessageBox.alert(res.data.message, "提示");
        } else {
          MessageBox.alert(res.data.message, "提示");
        }
      })
    },
    //手机号验证
    checkPhone(phone) {
      if (this.time == 60) {
        let message = '';
        let title = '手机号码错误';
        if (phone == null || phone == '') {
          message = "请输入绑定的手机号码"
          MessageBox.alert(message, title);
        } else {
          this.sendVerifyCode(phone)
        }
      }
    },
    getTerm() {
      if (this.time == 60) {
        let timer = setInterval(() => {
          if (this.time == 0) {
            clearInterval(timer);
            this.time = 60;
            this.valiText = '获取验证码';
          } else {
            this.valiText = this.time + '秒后重试';
            this.time--;
          }
        }, 1000);
      }
    },

    //打开忘记密码弹框
    openForgetPassword() {
      this.forgetPasswordModel = true;
    },
    //关闭忘记密码弹框
    closeForgetPassword() {
      this.forgetPasswordModel = false;
    },
    //教师忘记密码确定跳转至主站
    forgetPasswordOK() {
      window.open('https://m.21cnjy.com/', '_blank ');
      this.forgetPasswordModel = false;
      this.bindingPhoneModel = false;
    },
    //关闭绑定手机号弹框
    closeBindingPhoneModel() {
      this.bindingPhoneModel = false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/user/loginTeacher.vue